import { render, staticRenderFns } from "./participants.html?vue&type=template&id=2c87a620&scoped=true&"
import script from "./participants.js?vue&type=script&lang=js&"
export * from "./participants.js?vue&type=script&lang=js&"
import style0 from "./participants.scss?vue&type=style&index=0&id=2c87a620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87a620",
  null
  
)

export default component.exports